/**
 * URL Configuration Utility for Frontend App
 * 
 * Provides environment-aware URLs for cross-site linking.
 * Loads from replicated urls.json file.
 * 
 * DO NOT EDIT - This file is auto-generated by replication.
 * To modify URLs, edit shared/config/urls.json and run: npm run replicate:frontend
 */

import urlsConfig from './urls.json';

const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';
const env = isDevelopment ? 'development' : 'production';

const config = urlsConfig[env];

/**
 * Get the app site base URL
 */
export const getAppSiteUrl = () => config.appSite;

/**
 * Get the public site base URL
 */
export const getPublicSiteUrl = () => config.publicSite;

/**
 * Get a public site page URL
 * @param {string} page - Page identifier (home, about, contact, terms, privacy)
 */
export const getPublicPageUrl = (page) => {
  const pages = {
    home: '',
    about: '/about.html',
    contact: '/contact.html',
    terms: '/terms.html',
    privacy: '/privacy.html',
    faq: '/faq.html',
  };
  const path = pages[page] || '';
  return `${config.publicSite}${path}`;
};

/**
 * Get the login page URL (for redirects, etc.)
 */
export const getLoginUrl = () => `${config.appSite}/login`;

/**
 * Get the register page URL
 */
export const getRegisterUrl = () => `${config.appSite}/register`;

